import ProductLink from './ProductLink'

export default ProductLink
